import { render, staticRenderFns } from "./cadhorariosacessos.vue?vue&type=template&id=1128cd07&"
import script from "./cadhorariosacessos.vue?vue&type=script&lang=js&"
export * from "./cadhorariosacessos.vue?vue&type=script&lang=js&"
import style0 from "./cadhorariosacessos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports